/* Dunrobin Highland Distillery — theme behaviour */
(function () {
  'use strict';

  var routes = window.routes || {};

  function on(selector, event, handler, root) {
    (root || document).addEventListener(event, function (e) {
      var target = e.target.closest(selector);
      if (target) handler(e, target);
    });
  }

  function money(cents) {
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify?.currency?.active || 'GBP' });
  }

  /* ---------------------------------------------------------------------
     Read more — folds a long product description behind a toggle
     --------------------------------------------------------------------- */
  var READ_MORE_FOLD = 150; // px, keep in step with .is-collapsed max-height

  function initReadMore() {
    document.querySelectorAll('[data-read-more]:not([data-read-more-ready])').forEach(function (wrap) {
      var body = wrap.querySelector('.product__description');
      var btn = wrap.querySelector('.read-more__toggle');
      if (!body || !btn) return;
      wrap.setAttribute('data-read-more-ready', '');

      // Leave a little slack so a description that only just overflows the
      // fold isn't hidden behind a button for the sake of a line or two.
      if (body.scrollHeight <= READ_MORE_FOLD + 48) return;

      function set(open) {
        body.classList.toggle('is-collapsed', !open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? wrap.getAttribute('data-label-less') : wrap.getAttribute('data-label-more');
      }

      btn.hidden = false;
      set(false);
      btn.addEventListener('click', function () {
        set(btn.getAttribute('aria-expanded') !== 'true');
      });
    });
  }

  /* ---------------------------------------------------------------------
     Scroll reveal
     --------------------------------------------------------------------- */
  function initReveal() {
    var items = document.querySelectorAll('.reveal:not(.is-visible)');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    // The margin extends the trigger area a fifth of a screen below the
    // fold, so content is already fading in as it arrives rather than
    // appearing late — a fast flick or an anchor jump would otherwise land
    // on a blank section waiting for its animation.
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.05, rootMargin: '0px 0px 20% 0px' }
    );

    items.forEach(function (el) {
      // Anything the page loads already scrolled past — landing on an
      // anchor, or a restored scroll position — has had its entrance;
      // animating it if the visitor scrolls back up would look broken.
      if (el.getBoundingClientRect().bottom < 0) {
        el.classList.add('is-visible');
        return;
      }
      observer.observe(el);
    });
  }

  /* ---------------------------------------------------------------------
     Mobile navigation
     --------------------------------------------------------------------- */
  function initMobileNav() {
    var nav = document.getElementById('MobileNav');
    if (!nav) return;

    // The toggle announces the drawer's state to screen readers; without
    // this, "Menu, button" gives no clue that pressing it again closes it.
    function setExpanded(value) {
      document.querySelectorAll('[data-mobile-nav-open]').forEach(function (btn) {
        btn.setAttribute('aria-expanded', value ? 'true' : 'false');
      });
    }

    function open() {
      nav.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      setExpanded(true);
      var first = nav.querySelector('a, button');
      if (first) first.focus();
    }

    function close() {
      nav.classList.remove('is-open');
      document.body.style.overflow = '';
      setExpanded(false);
    }

    on('[data-mobile-nav-open]', 'click', open);
    on('[data-mobile-nav-close]', 'click', close);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) close();
    });
  }

  /* ---------------------------------------------------------------------
     Announcement bar rotation
     --------------------------------------------------------------------- */
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-announcement]'));
      if (this.dataset.autorotate !== 'true' || this.items.length < 2) return;

      var speed = (parseInt(this.dataset.speed, 10) || 6) * 1000;
      var index = 0;
      var self = this;

      this.timer = setInterval(function () {
        self.items[index].hidden = true;
        index = (index + 1) % self.items.length;
        self.items[index].hidden = false;
      }, speed);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }
  }

  if (!customElements.get('announcement-bar')) {
    customElements.define('announcement-bar', AnnouncementBar);
  }

  /* ---------------------------------------------------------------------
     Age gate
     --------------------------------------------------------------------- */
  function initAgeGate() {
    var gate = document.getElementById('AgeGate');
    if (!gate) return;

    // Never block the theme editor preview.
    if (window.Shopify && window.Shopify.designMode) return;

    var KEY = 'dunrobin:age-verified';
    // Per session by default: sessionStorage is cleared when the browsing
    // session ends, so a returning visitor is asked again.
    var perSession = gate.getAttribute('data-frequency') !== 'device';

    function store() {
      try {
        return perSession ? window.sessionStorage : window.localStorage;
      } catch (e) {
        return null;
      }
    }

    if (perSession) {
      // Drop any device-wide flag left by a previous configuration, otherwise
      // visitors who confirmed once would never be asked again.
      try {
        window.localStorage.removeItem(KEY);
      } catch (e) {
        /* storage unavailable */
      }
    }

    var verified = null;
    try {
      var s = store();
      verified = s && s.getItem(KEY);
    } catch (e) {
      verified = null;
    }

    if (verified === 'true') return;

    gate.hidden = false;
    gate.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    on(
      '[data-age-gate-accept]',
      'click',
      function () {
        try {
          var s = store();
          if (s) s.setItem(KEY, 'true');
        } catch (e) {
          /* private browsing — the gate simply shows again */
        }
        gate.classList.remove('is-open');
        gate.hidden = true;
        document.body.style.overflow = '';
      },
      gate
    );

    // Declining swaps in an apology and then leaves, rather than jumping away
    // the instant the visitor clicks.
    on(
      '[data-age-gate-decline]',
      'click',
      function (e, link) {
        var ask = gate.querySelector('[data-age-gate-ask]');
        var farewell = gate.querySelector('[data-age-gate-farewell]');
        if (!farewell) return; // no panel rendered — let the link do its job

        e.preventDefault();

        if (ask) ask.hidden = true;
        farewell.hidden = false;

        var remaining = parseInt(farewell.getAttribute('data-delay'), 10);
        if (isNaN(remaining) || remaining < 1) remaining = 5;

        var note = farewell.querySelector('[data-age-gate-countdown]');

        function paint() {
          if (!note) return;
          var template =
            remaining === 1
              ? note.getAttribute('data-singular')
              : note.getAttribute('data-plural');
          if (template) note.textContent = template.replace('__COUNT__', remaining);
        }

        paint();

        var timer = setInterval(function () {
          remaining -= 1;
          if (remaining > 0) {
            paint();
            return;
          }
          clearInterval(timer);
          window.location.href = link.href;
        }, 1000);
      },
      gate
    );
  }

  /* ---------------------------------------------------------------------
     Christmas popup
     --------------------------------------------------------------------- */
  function initXmasPopup() {
    var popup = document.getElementById('XmasPopup');
    if (!popup) return;

    // ?xmas_popup=1 shows it again for checking, ignoring the "already seen" flag.
    var forced = /[?&]xmas_popup=1(&|$)/.test(window.location.search);

    // Never block the theme editor preview.
    if (window.Shopify && window.Shopify.designMode && !forced) return;

    var KEY = 'dunrobin:xmas-popup-seen';
    var perSession = popup.getAttribute('data-frequency') !== 'device';

    function store() {
      try {
        return perSession ? window.sessionStorage : window.localStorage;
      } catch (e) {
        return null;
      }
    }

    try {
      var s = store();
      if (!forced && s && s.getItem(KEY) === 'true') return;
    } catch (e) {
      /* storage unavailable — the popup simply shows each visit */
    }

    var lastFocus = null;

    function focusables() {
      return Array.prototype.slice.call(popup.querySelectorAll('a[href], button'))
        .filter(function (el) {
          return el.tabIndex >= 0;
        });
    }

    function close() {
      popup.classList.remove('is-open');
      popup.hidden = true;
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }

    function onKey(e) {
      if (e.key === 'Escape') {
        close();
        return;
      }
      if (e.key !== 'Tab') return;

      // Keep Tab inside the dialog while it is open.
      var items = focusables();
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    function open() {
      // A visitor who has already followed a link away from the age gate, or
      // opened the cart, should not have a second panel land on top of it.
      if (popup.classList.contains('is-open')) return;
      var gate = document.getElementById('AgeGate');
      if (gate && gate.classList.contains('is-open')) return;

      try {
        var s = store();
        if (s) s.setItem(KEY, 'true');
      } catch (e) {
        /* private browsing — the popup simply shows again */
      }

      lastFocus = document.activeElement;
      popup.hidden = false;
      popup.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', onKey);

      var closeButton = popup.querySelector('.xmas-popup__close');
      if (closeButton) closeButton.focus({ preventScroll: true });
    }

    on('[data-xmas-popup-close]', 'click', close, popup);

    var delay = parseFloat(popup.getAttribute('data-delay'));
    if (isNaN(delay) || delay < 0) delay = 1;

    function schedule() {
      setTimeout(open, delay * 1000);
    }

    // First visit: the age gate comes first, and the popup follows once the
    // visitor confirms. Declining leaves the site, so it never shows.
    var gate = document.getElementById('AgeGate');
    if (gate && gate.classList.contains('is-open')) {
      on('[data-age-gate-accept]', 'click', schedule, gate);
    } else {
      schedule();
    }
  }

  /* ---------------------------------------------------------------------
     Cart
     --------------------------------------------------------------------- */
  var cartDrawer = document.getElementById('CartDrawer');

  function openCart() {
    if (!cartDrawer) return false;
    cartDrawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    return true;
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function refreshCartDrawer() {
    if (!cartDrawer) return Promise.resolve();

    // Re-render from the cart page, which is the single source of truth for
    // both the line items and the checkout form.
    return fetch(routes.cart_url || '/cart', { headers: { Accept: 'text/html' } })
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var body = document.getElementById('CartDrawerBody');
        var footer = document.getElementById('CartDrawerFooter');
        var newItems = doc.querySelector('.cart-items') || doc.querySelector('.cart-empty');
        var newFooter = doc.getElementById('CartFooterForm');

        // If the cart page could not render its lines — a Liquid error in the
        // items snippet, say — grafting only the footer would leave the drawer
        // claiming the bag is empty above a non-zero subtotal. Treat a missing
        // list as a failed refresh so the catch below takes over.
        if (!newItems) throw new Error('cart markup missing');

        if (body) {
          // The markup arrives dressed for the cart page. Strip the page-only
          // parts so the drawer keeps its own compact layout.
          newItems.classList.remove('cart-items--page');
          var heading = newItems.querySelector('.cart-items__header');
          if (heading) heading.remove();

          body.innerHTML = '';
          body.appendChild(newItems);
        }

        if (footer) {
          footer.innerHTML = '';
          if (newFooter) {
            // The page submits straight to checkout behind its age checkbox.
            // The drawer has no checkbox, so it sends the shopper to the cart
            // page to tick it rather than inheriting that button.
            newFooter.querySelectorAll('button[name="checkout"]').forEach(function (b) {
              var link = document.createElement('a');
              link.className = b.className;
              link.href = routes.cart_url || '/cart';
              link.textContent = b.textContent.trim();
              b.replaceWith(link);
            });
            footer.appendChild(newFooter);
            footer.hidden = false;
          } else {
            footer.hidden = true;
          }
        }
      })
      .catch(function () {
        // If the refresh fails, send the shopper to the cart page rather than
        // leaving them stuck in a drawer with no way to pay.
        window.location.href = routes.cart_url || '/cart';
      });
  }

  function changeLine(line, quantity) {
    return fetch(routes.cart_change_url || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        if (cartDrawer && cartDrawer.classList.contains('is-open')) {
          return refreshCartDrawer();
        }
        window.location.reload();
      });
  }

  function initCart() {
    on('[data-cart-open]', 'click', function (e) {
      if (openCart()) e.preventDefault();
    });
    on('[data-cart-close]', 'click', closeCart);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeCart();
    });

    on('[data-cart-remove]', 'click', function (e, el) {
      e.preventDefault();
      changeLine(parseInt(el.dataset.cartRemove, 10), 0);
    });

    on('[data-quantity-change]', 'click', function (e, el) {
      e.preventDefault();
      var line = parseInt(el.dataset.quantityChange, 10);
      var delta = parseInt(el.dataset.quantityDelta, 10);
      var input = document.querySelector('[data-quantity-input="' + line + '"]');
      if (!input) return;
      var next = Math.max(0, parseInt(input.value, 10) + delta);
      input.value = next;
      changeLine(line, next);
    });

    on('[data-quantity-input]', 'change', function (e, el) {
      changeLine(parseInt(el.dataset.quantityInput, 10), Math.max(0, parseInt(el.value, 10) || 0));
    });
  }

  /* ---------------------------------------------------------------------
     Product form — add to cart without a page reload
     --------------------------------------------------------------------- */
  function initProductForm() {
    on('[data-product-quantity-delta]', 'click', function (e, el) {
      e.preventDefault();
      var input = document.querySelector('[data-product-quantity]');
      if (!input) return;
      var delta = parseInt(el.dataset.productQuantityDelta, 10);
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
    });

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-product-form]');
      // Adding is always done in the background, drawer or no drawer. Letting
      // the form post natively would send the visitor off to the cart page.
      if (!form) return;

      e.preventDefault();

      var button = form.querySelector('[data-add-to-cart]');
      var label = form.querySelector('[data-add-to-cart-text]');
      var original = label ? label.textContent : '';

      if (button) button.setAttribute('aria-disabled', 'true');
      if (label) label.textContent = '…';

      fetch(routes.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          if (data.status) {
            if (label) label.textContent = data.description || data.message;
            return;
          }
          return fetch('/cart.js')
            .then(function (r) {
              return r.json();
            })
            .then(function (cart) {
              updateCartCount(cart.item_count);
              return refreshCartDrawer();
            })
            .then(function () {
              if (openCart()) return;
              // No drawer to confirm with, so the button says so instead and
              // settles back to its own label.
              if (!label) return;
              label.textContent = label.getAttribute('data-added-label') || 'Added';
              setTimeout(function () {
                label.textContent = original;
              }, 2000);
            });
        })
        .catch(function () {
          form.submit();
        })
        .finally(function () {
          if (button) button.removeAttribute('aria-disabled');
          if (label && label.textContent === '…') label.textContent = original;
        });
    });
  }

  /* ---------------------------------------------------------------------
     Variant picker
     --------------------------------------------------------------------- */
  function initVariantPicker() {
    var picker = document.querySelector('[data-variant-picker]');
    if (!picker) return;

    var dataEl = picker.querySelector('[data-variant-data]');
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    picker.addEventListener('change', function () {
      var selected = Array.from(picker.querySelectorAll('.variant-picker__input:checked')).map(function (input) {
        return input.value;
      });

      var match = variants.find(function (variant) {
        return variant.options.every(function (option, i) {
          return option === selected[i];
        });
      });

      var idInput = document.querySelector('[data-variant-id]');
      var button = document.querySelector('[data-add-to-cart]');
      var label = document.querySelector('[data-add-to-cart-text]');
      var priceEl = document.getElementById('ProductPrice');

      if (!match) {
        if (button) button.disabled = true;
        if (label) label.textContent = window.themeStrings.unavailable;
        return;
      }

      if (idInput) {
        idInput.value = match.id;
        idInput.disabled = false;
      }

      if (button) button.disabled = !match.available;
      if (label) label.textContent = match.available ? window.themeStrings.addToCart : window.themeStrings.soldOut;

      if (priceEl) {
        var html = '<div class="price' + (match.compare_at_price > match.price ? ' price--on-sale' : '') + '">';
        if (match.compare_at_price > match.price) {
          html += '<s class="price__regular">' + money(match.compare_at_price) + '</s>';
          html += '<span class="price__sale">' + money(match.price) + '</span>';
        } else {
          html += '<span class="price__regular">' + money(match.price) + '</span>';
        }
        priceEl.innerHTML = html + '</div>';
      }

      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url);
      }
    });
  }

  /* ---------------------------------------------------------------------
     Cart page age confirmation — blocks checkout until ticked
     --------------------------------------------------------------------- */
  function initAgeConfirm() {
    var box = document.querySelector('[data-age-confirm]');
    if (!box) return;

    var panel = document.getElementById('AgeConfirm');
    // Gate only the cart page's own button, never the drawer's.
    var scope = panel.closest('.cart-page') || document;
    var checkout = scope.querySelector('button[name="checkout"]');
    if (!checkout) return;

    function sync() {
      checkout.disabled = !box.checked;
      if (box.checked && panel) panel.classList.remove('is-invalid');
    }

    sync();
    box.addEventListener('change', sync);

    // If the button is reached without ticking, draw attention to the panel.
    checkout.addEventListener('click', function (e) {
      if (box.checked) return;
      e.preventDefault();
      if (panel) {
        panel.classList.add('is-invalid');
        panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      box.focus();
    });
  }

  /* ---------------------------------------------------------------------
     Misc
     --------------------------------------------------------------------- */
  function initAutoSubmit() {
    on('[data-auto-submit] select', 'change', function (e, el) {
      el.closest('form').submit();
    });
  }

  function initShare() {
    on('[data-share-link]', 'click', function (e, el) {
      if (!navigator.share) return;
      e.preventDefault();
      navigator.share({ title: document.title, url: el.href }).catch(function () {});
    });
  }

  /* ---------------------------------------------------------------------
     Article body — tidy text pasted in from Word or Outlook. It arrives with
     an empty paragraph after every real one for spacing, stray <meta> and
     picture-less <img> tags, and each photo in its own wrapper at its own
     size. The empties go, and runs of consecutive photos become one group.
     --------------------------------------------------------------------- */
  function initArticleBody() {
    var blank = /[\s ]+/g;

    function isBlank(el) {
      return !el.textContent.replace(blank, '') && !el.querySelector('img, iframe, video, hr, table');
    }

    // The link or picture a block holds, when a picture is all it holds.
    function pictureIn(el) {
      var tag = el.tagName;
      if (tag === 'IMG') return el;
      if (tag !== 'P' && tag !== 'DIV' && tag !== 'FIGURE') return null;
      var imgs = el.querySelectorAll('img');
      if (imgs.length !== 1 || el.textContent.replace(blank, '')) return null;
      var link = imgs[0].closest('a');
      return link && el.contains(link) ? link : imgs[0];
    }

    function shape(group) {
      var imgs = Array.prototype.slice.call(group.querySelectorAll('img'));
      function set() {
        if (!imgs.every(function (img) { return img.naturalWidth; })) return;
        var portrait = imgs.every(function (img) { return img.naturalHeight >= img.naturalWidth; });
        group.setAttribute('data-shape', portrait ? 'portrait' : 'landscape');
      }
      imgs.forEach(function (img) {
        if (!img.complete) img.addEventListener('load', set, { once: true });
      });
      set();
    }

    document.querySelectorAll('.article__body.rte:not([data-tidy])').forEach(function (body) {
      body.setAttribute('data-tidy', '');

      body.querySelectorAll('meta, img:not([src]), img[src=""]').forEach(function (el) { el.remove(); });
      body.querySelectorAll('p, div, h1, h2, h3, h4, h5, h6').forEach(function (el) {
        if (isBlank(el)) el.remove();
      });

      var run = [];
      function flush() {
        if (!run.length) return;
        var group = document.createElement('div');
        group.className = 'article__images';
        group.setAttribute('data-count', run.length);
        group.style.setProperty('--cols', run.length === 4 ? 2 : Math.min(run.length, 3));
        run[0].block.parentNode.insertBefore(group, run[0].block);
        run.forEach(function (item) {
          group.appendChild(item.picture);
          if (item.block !== item.picture) item.block.remove();
        });
        run = [];
        shape(group);
      }

      Array.prototype.slice.call(body.children).forEach(function (el) {
        var picture = pictureIn(el);
        if (picture) {
          run.push({ block: el, picture: picture });
        } else {
          flush();
        }
      });
      flush();

      // A first paragraph set wholly in bold is the standfirst.
      var first = body.querySelector(':scope > p, :scope > h2, :scope > h3');
      if (first && first.tagName === 'P') {
        var all = first.textContent.replace(blank, '');
        var bold = Array.prototype.map.call(first.querySelectorAll('b, strong'), function (b) {
          return b.textContent;
        }).join('').replace(blank, '');
        if (all && all === bold) first.classList.add('article__lead');
      }
    });
  }

  /* ---------------------------------------------------------------------
     Product gallery — thumbnails swap the large preview
     --------------------------------------------------------------------- */
  function initGallery() {
    on('[data-gallery-thumb]', 'click', function (e, thumb) {
      e.preventDefault();

      var gallery = thumb.closest('product-gallery');
      if (!gallery) return;

      var id = thumb.dataset.galleryThumb;

      gallery.querySelectorAll('[data-gallery-slide]').forEach(function (slide) {
        slide.hidden = slide.dataset.gallerySlide !== id;
      });

      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (el) {
        var active = el === thumb;
        el.classList.toggle('is-active', active);
        el.setAttribute('aria-current', active ? 'true' : 'false');
      });
    });
  }

  /* ---------------------------------------------------------------------
     Sticky Add to bag (phone) — mirrors the real button, shown only while
     the real one is off screen
     --------------------------------------------------------------------- */
  var stickyAtcTeardown = null;

  function initStickyAtc() {
    if (stickyAtcTeardown) {
      stickyAtcTeardown();
      stickyAtcTeardown = null;
    }

    var bar = document.querySelector('[data-sticky-atc]');
    var main = document.querySelector('[data-product-form] [data-add-to-cart]');
    if (!bar || !main || !('IntersectionObserver' in window)) return;

    var button = bar.querySelector('[data-sticky-atc-button]');
    var label = bar.querySelector('[data-sticky-atc-label]');
    var price = bar.querySelector('[data-sticky-atc-price]');
    var mainLabel = main.querySelector('[data-add-to-cart-text]');
    var mainPrice = document.getElementById('ProductPrice');

    function sync() {
      if (mainLabel && label) label.textContent = mainLabel.textContent.trim();
      if (button) button.disabled = main.disabled;
      if (mainPrice && price) price.innerHTML = mainPrice.innerHTML;
    }

    // Variant changes and the add-to-cart request rewrite those three nodes.
    var mirror = new MutationObserver(sync);
    mirror.observe(main, { attributes: true, attributeFilter: ['disabled'] });
    if (mainLabel) mirror.observe(mainLabel, { childList: true, characterData: true, subtree: true });
    if (mainPrice) mirror.observe(mainPrice, { childList: true, subtree: true });
    sync();

    // init runs again when any section reloads in the editor; bind once.
    if (button && !button.dataset.stickyBound) {
      button.dataset.stickyBound = 'true';
      button.addEventListener('click', function () {
        if (main.disabled || main.getAttribute('aria-disabled') === 'true') return;
        main.click();
      });
    }

    // The sticky header covers the top of the window, so a button tucked under
    // it counts as off screen. The footer is excluded so the bar never sits on
    // top of the links down there.
    var state = { main: true, footer: false };
    var footer = document.querySelector('.footer');

    var watcher = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.target === main) state.main = entry.isIntersecting;
          else state.footer = entry.isIntersecting;
        });

        var show = !state.main && !state.footer;
        bar.classList.toggle('is-visible', show);
        document.body.classList.toggle('has-sticky-atc', show);
      },
      { rootMargin: '-72px 0px 0px 0px' }
    );
    watcher.observe(main);
    if (footer) watcher.observe(footer);

    stickyAtcTeardown = function () {
      mirror.disconnect();
      watcher.disconnect();
      document.body.classList.remove('has-sticky-atc');
    };
  }

  /* ---------------------------------------------------------------------
     Back to top — shown once the visitor is past the top quarter of the page
     --------------------------------------------------------------------- */
  function initBackToTop() {
    var button = document.querySelector('[data-back-to-top]');
    if (!button) return;

    var queued = false;

    function update() {
      queued = false;
      // Read the page height each time: late images and revealed sections
      // change it, and a threshold fixed at load would drift.
      var past = window.scrollY > document.documentElement.scrollHeight * 0.25;
      button.classList.toggle('is-visible', past);
    }

    function queue() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    // A reload restores the old scroll position without a scroll event.
    update();

    button.addEventListener('click', function () {
      // Smooth unless the visitor asked for reduced motion: base.css sets
      // scroll-behavior on the root and switches it off for them.
      window.scrollTo({ top: 0 });

      // The button hides as it arrives, which would strand keyboard focus at
      // the foot of the page. Hand it to <body> so Tab starts from the top.
      var body = document.body;
      body.setAttribute('tabindex', '-1');
      body.focus({ preventScroll: true });
      body.addEventListener(
        'blur',
        function () {
          body.removeAttribute('tabindex');
        },
        { once: true }
      );
    });
  }

  function init() {
    initReveal();
    initGallery();
    initMobileNav();
    initAgeGate();
    initXmasPopup();
    initCart();
    initProductForm();
    initVariantPicker();
    initAgeConfirm();
    initAutoSubmit();
    initShare();
    initArticleBody();
    initStickyAtc();
    initBackToTop();
    initReadMore();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The theme editor re-renders sections in place.
  document.addEventListener('shopify:section:load', function () {
    initReveal();
    initArticleBody();
    initVariantPicker();
    initStickyAtc();
    initReadMore();
  });
})();
